<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['channelChange']);

const { t } = useI18n();

const CHANNEL_OPTIONS = [
  { id: 'both', labelKey: 'REPORT.CHANNEL_FILTER.BOTH' },
  { id: 'whatsapp', labelKey: 'REPORT.CHANNEL_FILTER.WHATSAPP' },
  { id: 'email', labelKey: 'REPORT.CHANNEL_FILTER.EMAIL' },
];

const selected = ref('both');

const selectChannel = channelId => {
  if (selected.value === channelId) return;
  selected.value = channelId;
  emit('channelChange', channelId);
};
</script>

<template>
  <div
    class="inline-flex items-center p-0.5 rounded-lg bg-n-alpha-1 border border-n-weak"
    role="group"
    :aria-label="t('REPORT.CHANNEL_FILTER.LABEL')"
  >
    <button
      v-for="option in CHANNEL_OPTIONS"
      :key="option.id"
      type="button"
      class="px-3 py-1 text-sm rounded-md whitespace-nowrap transition-colors"
      :class="
        selected === option.id
          ? 'bg-n-solid-3 text-n-slate-12 font-medium'
          : 'text-n-slate-11 hover:text-n-slate-12'
      "
      @click="selectChannel(option.id)"
    >
      {{ t(option.labelKey) }}
    </button>
  </div>
</template>
